import React from 'react';
import './svgs.css';

// icons.tsx

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export const MailIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.8}
      className={className}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
      />
    </svg>
  );
};

export const OpenEye: React.FC<IconProps> = ({
  size = 18,
  className = '',
  ...props
}) => {
  return (
    <svg width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.8}
      className={className}
      {...props}>
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"></circle>
    </svg>
  );
};

export const CloseEye: React.FC<IconProps> = ({
  size = 18,
  className = '',
  ...props
}) => {
  return (
    <svg width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.8}
      className={className}
      {...props}>
      <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18M10.477 10.477A3 3 0 0013.5 13.5M6.228 6.228A10.45 10.45 0 003 12c1.274 4.057 5.065 7 9 7a9.9 9.9 0 004.772-1.228M9.772 9.772A3 3 0 0112 9a3 3 0 013 3c0 .815-.326 1.555-.856 2.092"></path>
      <path stroke-linecap="round" stroke-linejoin="round" d="M17.772 17.772A10.45 10.45 0 0021 12c-1.274-4.057-5.065-7-9-7a9.9 9.9 0 00-4.772 1.228"></path>
    </svg>
  );
};

export const PitchViewIcon: React.FC<IconProps> = ({
  size = 16,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M0.566406 13.1453C0.566406 14.0943 1.33249 14.8604 2.28152 14.8604H13.7156C14.6646 14.8604 15.4307 14.0943 15.4307 13.1453V5.14145H0.566406V13.1453ZM6.28344 7.99996C6.28344 7.79415 6.39206 7.60549 6.57501 7.50258C6.75223 7.39968 6.9752 7.40539 7.15243 7.5083L10.0109 9.22341C10.1825 9.32632 10.2911 9.51498 10.2911 9.71507C10.2911 9.91517 10.1882 10.1038 10.0109 10.2067L7.15243 11.9218C7.06095 11.979 6.95805 12.0019 6.86086 12.0019C6.76367 12.0019 6.66648 11.979 6.58072 11.9276C6.4035 11.8247 6.28916 11.636 6.28916 11.4302V7.99996H6.28344ZM6.04904 3.99804L8.90756 1.13953H6.51784L3.65932 3.99804H6.04904ZM10.051 3.99804L12.9095 1.13953H10.5198L7.66124 3.99804H10.051ZM4.90563 1.13953H1.70981C1.08094 1.13953 0.566406 1.65406 0.566406 2.28293V3.99804H2.04712L4.90563 1.13953ZM14.5045 1.16239L11.6689 3.99804H15.4364V2.28293C15.4364 1.72266 15.0362 1.25958 14.5102 1.16239H14.5045Z"
        fill={fill}
      />
    </svg>
  );
};

export const HiredCandidateIcon: React.FC<IconProps> = ({
  size = 15,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.07655 1.25146L0.908691 2.10001C0.753122 2.14172 0.607294 2.21367 0.479536 2.31174C0.351778 2.40982 0.244593 2.5321 0.164103 2.67161C0.0836129 2.81112 0.0313948 2.96511 0.0104312 3.12481C-0.0105323 3.2845 0.000169448 3.44676 0.0419253 3.60231L2.85243 14.0932C2.89414 14.2488 2.96608 14.3946 3.06416 14.5223C3.16224 14.6501 3.28452 14.7573 3.42403 14.8378C3.56354 14.9183 3.71753 14.9705 3.87723 14.9914C4.03692 15.0124 4.19918 15.0017 4.35473 14.96L7.88415 14.014H6.00348C5.49242 14.014 5.0023 13.811 4.64094 13.4496C4.27957 13.0883 4.07655 12.5981 4.07655 12.0871V1.25146Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9375 12.0871V1.22622C14.9375 0.901009 14.8083 0.589114 14.5783 0.359153C14.3484 0.129191 14.0365 0 13.7113 0H6.00357C5.67835 0 5.36646 0.129191 5.1365 0.359153C4.90653 0.589114 4.77734 0.901009 4.77734 1.22622V12.0871C4.77734 12.7646 5.32669 13.3133 6.00357 13.3133H13.7113C14.0365 13.3133 14.3484 13.1841 14.5783 12.9541C14.8083 12.7242 14.9375 12.4123 14.9375 12.0871ZM7.75532 11.2112H11.9595C12.0989 11.2112 12.2326 11.1558 12.3311 11.0573C12.4297 10.9587 12.485 10.825 12.485 10.6857C12.485 10.5463 12.4297 10.4126 12.3311 10.3141C12.2326 10.2155 12.0989 10.1601 11.9595 10.1601H7.75532C7.61594 10.1601 7.48227 10.2155 7.38371 10.3141C7.28516 10.4126 7.22979 10.5463 7.22979 10.6857C7.22979 10.825 7.28516 10.9587 7.38371 11.0573C7.48227 11.1558 7.61594 11.2112 7.75532 11.2112ZM8.45602 9.45944H11.2588C11.3982 9.45944 11.5319 9.40408 11.6304 9.30552C11.729 9.20697 11.7843 9.0733 11.7843 8.93392C11.7843 8.79454 11.729 8.66087 11.6304 8.56232C11.5319 8.46376 11.3982 8.40839 11.2588 8.40839H8.45602C8.31664 8.40839 8.18297 8.46376 8.08441 8.56232C7.98586 8.66087 7.93049 8.79454 7.93049 8.93392C7.93049 9.0733 7.98586 9.20697 8.08441 9.30552C8.18297 9.40408 8.31664 9.45944 8.45602 9.45944ZM10.5791 4.73042C10.8935 4.56857 11.1443 4.30577 11.2913 3.98422C11.4383 3.66267 11.4729 3.30105 11.3896 2.95744C11.3064 2.61383 11.11 2.30818 10.8321 2.0896C10.5543 1.87101 10.211 1.75217 9.85742 1.75217C9.50386 1.75217 9.16057 1.87101 8.88269 2.0896C8.6048 2.30818 8.40846 2.61383 8.32519 2.95744C8.24192 3.30105 8.27657 3.66267 8.42356 3.98422C8.57055 4.30577 8.82136 4.56857 9.13569 4.73042C9.06154 4.73431 8.9889 4.75288 8.92198 4.78508L8.32148 5.08568C8.11787 5.18754 7.94665 5.34408 7.82697 5.53776C7.7073 5.73144 7.64391 5.95461 7.64391 6.18227V6.80029C7.64391 7.09038 7.87934 7.32581 8.16943 7.32581H11.6729C11.8123 7.32581 11.946 7.27045 12.0445 7.17189C12.1431 7.07334 12.1985 6.93967 12.1985 6.80029V6.2054C12.1985 5.71981 11.9126 5.28047 11.469 5.08428L10.7711 4.77457C10.7102 4.74863 10.6452 4.73369 10.5791 4.73042Z"
        fill={fill}
      />
    </svg>
  );
};

export const UsersIcon: React.FC<IconProps> = ({
  size = 16,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_1306_53463)">
        <path
          d="M7.88598 7.70725C8.94479 7.70725 9.86166 7.32747 10.6108 6.57819C11.36 5.82907 11.7397 4.91245 11.7397 3.85352C11.7397 2.7949 11.36 1.87818 10.6107 1.12878C9.86141 0.379748 8.94466 0 7.88598 0C6.82701 0 5.91036 0.379749 5.16124 1.1289C4.41212 1.87806 4.03221 2.7948 4.03221 3.85352C4.03221 4.91245 4.41208 5.8292 5.16136 6.57835C5.91064 7.32738 6.82739 7.70725 7.88598 7.70725ZM14.629 12.3032C14.6074 11.9914 14.5637 11.6513 14.4993 11.2922C14.4344 10.9304 14.3508 10.5883 14.2507 10.2757C14.1473 9.95259 14.0067 9.63352 13.8329 9.32771C13.6524 9.01034 13.4405 8.73397 13.2027 8.50656C12.9541 8.26865 12.6496 8.07737 12.2976 7.93781C11.9467 7.79906 11.5579 7.72875 11.1421 7.72875C10.9787 7.72875 10.8208 7.79575 10.5157 7.99437C10.2989 8.13558 10.0814 8.27579 9.86325 8.415C9.65366 8.54856 9.36972 8.67368 9.019 8.78697C8.67685 8.89768 8.32944 8.95384 7.98654 8.95384C7.64367 8.95384 7.29635 8.89768 6.95382 8.78697C6.60351 8.67378 6.31958 8.54869 6.1102 8.41512C5.86739 8.25997 5.6477 8.11837 5.45714 7.99422C5.15246 7.79563 4.99436 7.72859 4.83105 7.72859C4.41502 7.72859 4.02637 7.79903 3.67565 7.93797C3.32384 8.07725 3.01928 8.26853 2.77037 8.50669C2.53272 8.73422 2.32069 9.01043 2.1405 9.32771C1.96681 9.63349 1.82619 9.95246 1.72266 10.2758C1.62266 10.5885 1.53906 10.9304 1.47413 11.2922C1.40978 11.6508 1.3661 11.991 1.34447 12.3035C1.32296 12.618 1.3123 12.9331 1.3125 13.2484C1.3125 14.0836 1.578 14.7597 2.10156 15.2583C2.61865 15.7504 3.30284 16.0001 4.13487 16.0001H11.839C12.671 16.0001 13.3549 15.7506 13.8721 15.2584C14.3958 14.7601 14.6613 14.0838 14.6613 13.2482C14.6612 12.9259 14.6504 12.6079 14.629 12.3032Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1306_53463">
          <rect width="16" height="16" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TrendUpArrowIcon: React.FC<IconProps> = ({
  size = 14,
  className = '',
  fill = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={11}
      height={size}
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.24688 13.2545C6.24688 13.6662 5.91249 14 5.5 14C5.08751 14 4.75313 13.6662 4.75313 13.2545L6.24688 13.2545ZM4.97188 0.218368C5.26355 -0.0727885 5.73645 -0.0727886 6.02813 0.218368L10.7812 4.96303C11.0729 5.25419 11.0729 5.72625 10.7812 6.01741C10.4896 6.30857 10.0167 6.30857 9.725 6.01741L5.5 1.79993L1.27501 6.01741C0.983336 6.30857 0.510432 6.30857 0.218757 6.01741C-0.0729175 5.72626 -0.0729175 5.25419 0.218757 4.96303L4.97188 0.218368ZM4.75313 13.2545L4.75313 0.745553L6.24688 0.745553L6.24688 13.2545L4.75313 13.2545Z"
        fill={fill}
      />
    </svg>
  );
};

export const TrendDownArrowIcon: React.FC<IconProps> = ({
  size = 14,
  className = '',
  fill = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={11}
      height={size}
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4.75312 0.745522C4.75312 0.333778 5.0875 9.87936e-07 5.49999 9.13391e-07C5.91249 8.38846e-07 6.24687 0.333778 6.24687 0.745521L4.75312 0.745522ZM6.02812 13.7816C5.73645 14.0728 5.26355 14.0728 4.97187 13.7816L0.218756 9.03697C-0.0729198 8.74581 -0.0729199 8.27375 0.218756 7.98259C0.51043 7.69143 0.983329 7.69143 1.275 7.98259L5.5 12.2001L9.72499 7.98259C10.0167 7.69143 10.4896 7.69143 10.7812 7.98259C11.0729 8.27374 11.0729 8.74581 10.7812 9.03696L6.02812 13.7816ZM6.24687 0.745521L6.24687 13.2544L4.75312 13.2544L4.75312 0.745522L6.24687 0.745521Z"
        fill={fill}
      />
    </svg>
  );
};

export const UpArrowIcon = TrendUpArrowIcon;
export const DownArrowIcon = TrendDownArrowIcon;

export const UnchangedTrendIcon: React.FC<IconProps> = ({
  size = 14,
  className = '',
  fill = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={10}
      height={size}
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    ><circle
        cx="5"
        cy="7"
        r="3"
        fill={fill}
      />
    </svg>
  );
};

export const NeutralDotIcon = UnchangedTrendIcon;


export const CandidatesIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={17}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14.2157 16.6909H3.78162C3.47285 16.6907 3.17677 16.568 2.95843 16.3497C2.7401 16.1313 2.61736 15.8352 2.61719 15.5265V1.16509C2.61719 0.856316 2.73976 0.560169 2.95797 0.34171C3.17619 0.12325 3.4722 0.000346938 3.78097 0H14.2151C14.5239 0.00017342 14.8199 0.12291 15.0383 0.341247C15.2566 0.559584 15.3793 0.855662 15.3795 1.16444V15.5258C15.3793 15.8346 15.2566 16.1307 15.0383 16.349C14.8199 16.5673 14.5239 16.6901 14.2151 16.6903M3.78162 0.981818C3.73324 0.981991 3.68689 1.00129 3.65268 1.0355C3.61847 1.06971 3.59918 1.11606 3.59901 1.16444V15.5258C3.59918 15.5742 3.61847 15.6205 3.65268 15.6548C3.68689 15.689 3.73324 15.7083 3.78162 15.7084H14.2151C14.2635 15.7083 14.3098 15.689 14.344 15.6548C14.3782 15.6205 14.3975 15.5742 14.3977 15.5258V1.16509C14.3975 1.11671 14.3782 1.07036 14.344 1.03615C14.3098 1.00194 14.2635 0.982645 14.2151 0.982473L3.78162 0.981818Z"
        fill={fill}
      />

      <path
        d="M16.8545 16.0364H14.8909C14.7607 16.0364 14.6358 15.9846 14.5438 15.8926C14.4517 15.8005 14.4 15.6756 14.4 15.5454C14.4 15.4153 14.4517 15.2904 14.5438 15.1983C14.6358 15.1063 14.7607 15.0545 14.8909 15.0545H16.8545C16.8978 15.054 16.9391 15.0366 16.9697 15.006C17.0003 14.9755 17.0177 14.9341 17.0182 14.8909V1.8C17.0177 1.75675 17.0003 1.71543 16.9697 1.68485C16.9391 1.65427 16.8978 1.63687 16.8545 1.63636H14.8909C14.7607 1.63636 14.6358 1.58464 14.5438 1.49258C14.4517 1.40051 14.4 1.27565 14.4 1.14545C14.4 1.01525 14.4517 0.890388 14.5438 0.798325C14.6358 0.706262 14.7607 0.654541 14.8909 0.654541H16.8545C17.1583 0.654541 17.4497 0.775223 17.6645 0.990037C17.8793 1.20485 18 1.4962 18 1.8V14.8909C18 15.1947 17.8793 15.486 17.6645 15.7009C17.4497 15.9157 17.1583 16.0364 16.8545 16.0364ZM3.10909 16.0364H1.14545C0.841661 16.0364 0.55031 15.9157 0.335496 15.7009C0.120682 15.486 0 15.1947 0 14.8909V1.8C0 1.4962 0.120682 1.20485 0.335496 0.990037C0.55031 0.775223 0.841661 0.654541 1.14545 0.654541H3.10909C3.23929 0.654541 3.36415 0.706262 3.45622 0.798325C3.54828 0.890388 3.6 1.01525 3.6 1.14545C3.6 1.27565 3.54828 1.40051 3.45622 1.49258C3.36415 1.58464 3.23929 1.63636 3.10909 1.63636H1.14545C1.10221 1.63687 1.06089 1.65427 1.03031 1.68485C0.999732 1.71543 0.982328 1.75675 0.981818 1.8V14.8909C0.982328 14.9341 0.999732 14.9755 1.03031 15.006C1.06089 15.0366 1.10221 15.054 1.14545 15.0545H3.10909C3.23929 15.0545 3.36415 15.1063 3.45622 15.1983C3.54828 15.2904 3.6 15.4153 3.6 15.5454C3.6 15.6756 3.54828 15.8005 3.45622 15.8926C3.36415 15.9846 3.23929 16.0364 3.10909 16.0364Z"
        fill={fill}
      />

      <path
        d="M11.7137 9.4909H6.2856C6.15343 9.49079 6.02329 9.45832 5.90656 9.39633C5.78983 9.33433 5.69005 9.24471 5.61593 9.13527C5.54181 9.02584 5.49561 8.89992 5.48136 8.76852C5.46711 8.63712 5.48524 8.50423 5.53418 8.38145L5.72269 7.91149C5.8347 7.63011 6.00694 7.37666 6.22732 7.16894C6.44771 6.96122 6.7109 6.80426 6.9984 6.70909L7.40945 6.57163C7.08561 6.11924 6.9131 5.57605 6.91658 5.0197C6.87814 4.42583 7.07527 3.84074 7.46525 3.39121C7.85523 2.94169 8.40665 2.66394 9 2.61818C9.59335 2.66394 10.1448 2.94169 10.5347 3.39121C10.9247 3.84074 11.1219 4.42583 11.0834 5.0197C11.0869 5.57605 10.9144 6.11924 10.5905 6.57163L11.0016 6.70909C11.2892 6.80418 11.5525 6.9611 11.773 7.16883C11.9935 7.37655 12.1659 7.63004 12.278 7.91149L12.4652 8.38145C12.5143 8.50422 12.5325 8.63716 12.5184 8.76863C12.5042 8.90009 12.458 9.02608 12.3838 9.13556C12.3097 9.24504 12.2098 9.33468 12.093 9.39663C11.9762 9.45858 11.846 9.49095 11.7137 9.4909ZM6.54087 8.50909H11.4591L11.3662 8.27607C11.3069 8.12733 11.2159 7.99334 11.0994 7.88345C10.983 7.77356 10.8439 7.69042 10.692 7.63985L9.78938 7.33941C9.67981 7.30291 9.58199 7.23779 9.50603 7.15079C9.43008 7.06379 9.37876 6.95807 9.35738 6.84458C9.3364 6.72881 9.34669 6.60954 9.38719 6.49908C9.42769 6.38863 9.49694 6.29098 9.58778 6.21621C9.75502 6.06593 9.88759 5.88108 9.97631 5.67448C10.065 5.46788 10.1078 5.24446 10.1016 5.0197C10.1379 4.68641 10.0433 4.35203 9.83781 4.08715C9.63228 3.82226 9.33188 3.64759 9 3.6C8.66812 3.64759 8.36772 3.82226 8.16219 4.08715C7.95665 4.35203 7.86207 4.68641 7.8984 5.0197C7.89222 5.24446 7.93496 5.46788 8.02368 5.67448C8.11241 5.88108 8.24498 6.06593 8.41222 6.21621C8.50318 6.2909 8.57255 6.38852 8.61317 6.49898C8.65379 6.60945 8.66418 6.72875 8.64327 6.84458C8.62189 6.95807 8.57057 7.06379 8.49462 7.15079C8.41867 7.23779 8.32084 7.30291 8.21127 7.33941L7.308 7.6405C7.15621 7.69093 7.01725 7.77387 6.90081 7.88353C6.78437 7.99318 6.69326 8.12692 6.63382 8.27541L6.54087 8.50909Z"
        fill={fill}
      />

      <path
        d="M12.9273 12.1091H5.07273C4.94253 12.1091 4.81767 12.0574 4.7256 11.9653C4.63354 11.8732 4.58182 11.7484 4.58182 11.6182C4.58182 11.488 4.63354 11.3631 4.7256 11.2711C4.81767 11.179 4.94253 11.1273 5.07273 11.1273H12.9273C13.0575 11.1273 13.1823 11.179 13.2744 11.2711C13.3665 11.3631 13.4182 11.488 13.4182 11.6182C13.4182 11.7484 13.3665 11.8732 13.2744 11.9653C13.1823 12.0574 13.0575 12.1091 12.9273 12.1091ZM12.9273 14.0727H5.07273C4.94253 14.0727 4.81767 14.021 4.7256 13.9289C4.63354 13.8369 4.58182 13.712 4.58182 13.5818C4.58182 13.4516 4.63354 13.3268 4.7256 13.2347C4.81767 13.1426 4.94253 13.0909 5.07273 13.0909H12.9273C13.0575 13.0909 13.1823 13.1426 13.2744 13.2347C13.3665 13.3268 13.4182 13.4516 13.4182 13.5818C13.4182 13.712 13.3665 13.8369 13.2744 13.9289C13.1823 14.021 13.0575 14.0727 12.9273 14.0727Z"
        fill={fill}
      />
    </svg>
  );
};

export const FilledCandidatesIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={16}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M1.875 1.1125V14.825C1.87564 14.9899 1.89877 15.1539 1.94375 15.3125H1.09375C0.804176 15.3109 0.526928 15.1951 0.322165 14.9903C0.117402 14.7856 0.00164069 14.5083 0 14.2188V1.71875C0.00164069 1.42918 0.117402 1.15193 0.322165 0.947165C0.526928 0.742402 0.804176 0.626641 1.09375 0.625H1.94375C1.89877 0.783617 1.87564 0.94763 1.875 1.1125ZM17.1875 1.71875V14.2188C17.1859 14.5083 17.0701 14.7856 16.8653 14.9903C16.6606 15.1951 16.3833 15.3109 16.0938 15.3125H15.2437C15.2887 15.1539 15.3119 14.9899 15.3125 14.825V1.1125C15.3119 0.94763 15.2887 0.783617 15.2437 0.625H16.0938C16.3833 0.626641 16.6606 0.742402 16.8653 0.947165C17.0701 1.15193 17.1859 1.42918 17.1875 1.71875ZM10.8531 7.9025C10.7965 7.76048 10.7096 7.63253 10.5984 7.5276C10.4872 7.42267 10.3544 7.34329 10.2094 7.295L9.3475 7.00813C9.24288 6.97327 9.14947 6.91109 9.07694 6.82802C9.00442 6.74494 8.95541 6.644 8.935 6.53562C8.91496 6.42509 8.92479 6.3112 8.96346 6.20573C9.00214 6.10025 9.06826 6.00701 9.155 5.93563C9.31469 5.79212 9.44128 5.61562 9.526 5.41835C9.61071 5.22107 9.65153 5.00774 9.64563 4.79312C9.68031 4.47487 9.59 4.15559 9.39375 3.90266C9.19749 3.64973 8.91065 3.48295 8.59375 3.4375C8.27685 3.48295 7.99001 3.64973 7.79376 3.90266C7.5975 4.15559 7.50719 4.47487 7.54188 4.79312C7.53597 5.00774 7.57679 5.22107 7.6615 5.41835C7.74622 5.61562 7.87281 5.79212 8.0325 5.93563C8.11936 6.00694 8.1856 6.10015 8.22438 6.20563C8.26317 6.31111 8.27309 6.42503 8.25313 6.53562C8.23271 6.644 8.18371 6.74494 8.11118 6.82802C8.03866 6.91109 7.94525 6.97327 7.84062 7.00813L6.97813 7.29563C6.83319 7.34378 6.7005 7.42297 6.58932 7.52768C6.47813 7.63238 6.39113 7.76009 6.33438 7.90187L6.24563 8.125H10.9419L10.8531 7.9025Z"
        fill={fill}
      />

      <path
        d="M13.5756 0H3.6125C3.31755 -4.65448e-08 3.03468 0.117124 2.82606 0.325623C2.61745 0.534122 2.50017 0.81693 2.5 1.11187V14.825C2.50017 15.1198 2.61736 15.4025 2.82584 15.611C3.03432 15.8195 3.31704 15.9367 3.61188 15.9369H13.575C13.8698 15.9367 14.1525 15.8195 14.361 15.611C14.5695 15.4025 14.6867 15.1198 14.6869 14.825V1.1125C14.6867 0.817663 14.5695 0.53495 14.361 0.326468C14.1525 0.117987 13.8698 0.000790547 13.575 0.000624955M5.28437 8.00313L5.46438 7.55437C5.57132 7.2857 5.73579 7.04369 5.94623 6.84535C6.15667 6.647 6.40797 6.49713 6.6825 6.40625L7.075 6.275C6.76578 5.84303 6.60105 5.32435 6.60438 4.79312C6.56767 4.22606 6.7559 3.66738 7.12828 3.23814C7.50066 2.80891 8.02718 2.5437 8.59375 2.5C9.16032 2.5437 9.68684 2.80891 10.0592 3.23814C10.4316 3.66738 10.6198 4.22606 10.5831 4.79312C10.5864 5.32435 10.4217 5.84303 10.1125 6.275L10.505 6.40625C10.7796 6.49705 11.0311 6.64689 11.2416 6.84524C11.4522 7.04359 11.6167 7.28563 11.7237 7.55437L11.9025 8.00313C11.9494 8.12036 11.9668 8.24729 11.9533 8.37283C11.9398 8.49836 11.8957 8.61866 11.8248 8.7232C11.754 8.82774 11.6587 8.91333 11.5472 8.97248C11.4356 9.03163 11.3113 9.06254 11.185 9.0625H6.00187C5.87567 9.06239 5.75141 9.03138 5.63995 8.97219C5.52848 8.913 5.4332 8.82742 5.36243 8.72292C5.29166 8.61843 5.24754 8.4982 5.23394 8.37273C5.22033 8.24726 5.23765 8.12036 5.28437 8.00313ZM12.3438 13.4375H4.84375C4.71943 13.4375 4.6002 13.3881 4.51229 13.3002C4.42439 13.2123 4.375 13.0931 4.375 12.9688C4.375 12.8444 4.42439 12.7252 4.51229 12.6373C4.6002 12.5494 4.71943 12.5 4.84375 12.5H12.3438C12.4681 12.5 12.5873 12.5494 12.6752 12.6373C12.7631 12.7252 12.8125 12.8444 12.8125 12.9688C12.8125 13.0931 12.7631 13.2123 12.6752 13.3002C12.5873 13.3881 12.4681 13.4375 12.3438 13.4375ZM12.3438 11.5625H4.84375C4.71943 11.5625 4.6002 11.5131 4.51229 11.4252C4.42439 11.3373 4.375 11.2181 4.375 11.0938C4.375 10.9694 4.42439 10.8502 4.51229 10.7623C4.6002 10.6744 4.71943 10.625 4.84375 10.625H12.3438C12.4681 10.625 12.5873 10.6744 12.6752 10.7623C12.7631 10.8502 12.8125 10.9694 12.8125 11.0938C12.8125 11.2181 12.7631 11.3373 12.6752 11.4252C12.5873 11.5131 12.4681 11.5625 12.3438 11.5625Z"
        fill={fill}
      />
    </svg>
  );
};


export const ConnectionsIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58583 11.0667C5.80172 11.0676 6.96755 11.551 7.82724 12.4109C8.68692 13.2707 9.17017 14.4366 9.17083 15.6525C9.17083 16.3017 8.76167 16.8675 8.00917 17.2567C7.17833 17.6867 5.88333 17.9167 4.58583 17.9167C3.2875 17.9167 1.9925 17.6867 1.16167 17.2567C0.409167 16.8675 0 16.3017 0 15.6525C0.000662389 14.4365 0.484024 13.2704 1.34389 12.4106C2.20376 11.5507 3.3698 11.0674 4.58583 11.0667ZM4.58583 12.3167C3.70125 12.3171 2.85303 12.6687 2.22753 13.2942C1.60204 13.9197 1.25044 14.7679 1.25 15.6525C1.25 15.8792 1.4725 16.01 1.73583 16.1467C2.42583 16.5034 3.5075 16.6667 4.58583 16.6667C5.66333 16.6667 6.745 16.5034 7.435 16.1467C7.69833 16.01 7.92083 15.8792 7.92083 15.6525C7.92061 14.768 7.5692 13.9198 6.94384 13.2943C6.31848 12.6688 5.47034 12.3171 4.58583 12.3167ZM13.3392 4.40002C14.5552 4.40069 15.7212 4.88405 16.5811 5.74392C17.441 6.60378 17.9243 7.76982 17.925 8.98586C17.925 9.63502 17.5158 10.2009 16.7633 10.59C15.9325 11.02 14.6375 11.25 13.3392 11.25C12.0408 11.25 10.7467 11.02 9.91583 10.59C9.16333 10.2009 8.75417 9.63502 8.75417 8.98586C8.75483 7.76997 9.23808 6.60405 10.0978 5.74421C10.9574 4.88437 12.1233 4.40091 13.3392 4.40002ZM13.3392 5.65002C12.4547 5.65047 11.6065 6.00209 10.9812 6.62761C10.3558 7.25312 10.0044 8.10135 10.0042 8.98586C10.0042 9.21252 10.2267 9.34336 10.49 9.48002C11.18 9.83669 12.2617 10 13.3392 10C14.4167 10 15.4992 9.83669 16.1892 9.48002C16.4525 9.34336 16.675 9.21252 16.675 8.98586C16.6746 8.10128 16.323 7.25305 15.6975 6.62756C15.072 6.00206 14.2238 5.65047 13.3392 5.65002Z"
        fill={fill}
        fillOpacity={0.8}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58557 6.66667C6.14474 6.66667 7.41057 7.9325 7.41057 9.49167C7.38871 10.2265 7.08145 10.9238 6.55397 11.4359C6.02649 11.9479 5.32028 12.2343 4.58516 12.2343C3.85003 12.2343 3.14383 11.9479 2.61634 11.4359C2.08886 10.9238 1.7816 10.2265 1.75974 9.49167C1.75974 7.9325 3.02641 6.66667 4.58557 6.66667ZM4.58557 7.91667C3.71557 7.91667 3.00974 8.6225 3.00974 9.49167C3.01921 9.90322 3.18934 10.2947 3.48376 10.5825C3.77818 10.8702 4.1735 11.0313 4.58516 11.0313C4.99682 11.0313 5.39214 10.8702 5.68655 10.5825C5.98097 10.2947 6.15111 9.90322 6.16057 9.49167C6.16057 8.6225 5.45474 7.91667 4.58557 7.91667ZM13.3389 0C14.8981 0 16.1647 1.26583 16.1647 2.825C16.1647 4.38417 14.8981 5.65 13.3389 5.65C11.7797 5.65 10.5139 4.38417 10.5139 2.825C10.5139 1.26583 11.7797 0 13.3389 0ZM13.3389 1.25C13.132 1.25011 12.9271 1.29098 12.7359 1.37027C12.5448 1.44957 12.3711 1.56573 12.2249 1.71214C12.0786 1.85855 11.9626 2.03233 11.8835 2.22356C11.8045 2.41479 11.7638 2.61973 11.7639 2.82667C11.764 3.03361 11.8049 3.2385 11.8842 3.42965C11.9635 3.6208 12.0796 3.79445 12.226 3.94071C12.3725 4.08696 12.5462 4.20294 12.7375 4.28203C12.9287 4.36112 13.1336 4.40178 13.3406 4.40167C13.5475 4.40156 13.7524 4.36069 13.9436 4.28139C14.1347 4.2021 14.3084 4.08593 14.4546 3.93953C14.6009 3.79312 14.7168 3.61934 14.7959 3.42811C14.875 3.23688 14.9157 3.03194 14.9156 2.825C14.9155 2.61806 14.8746 2.41317 14.7953 2.22202C14.716 2.03087 14.5998 1.85721 14.4534 1.71096C14.307 1.56471 14.1332 1.44873 13.942 1.36963C13.7508 1.29054 13.5459 1.24989 13.3389 1.25ZM16.6747 13.1242C16.675 12.9584 16.741 12.7995 16.8584 12.6825C16.9758 12.5654 17.1348 12.4998 17.3006 12.5C17.4663 12.5002 17.6252 12.5663 17.7423 12.6836C17.8593 12.801 17.925 12.9601 17.9247 13.1258L17.9222 15.6275C17.9216 16.2349 17.6798 16.8171 17.2501 17.2463C16.8204 17.6756 16.2379 17.9167 15.6306 17.9167H11.0456C10.8798 17.9167 10.7208 17.8508 10.6036 17.7336C10.4864 17.6164 10.4206 17.4574 10.4206 17.2917C10.4206 17.1259 10.4864 16.9669 10.6036 16.8497C10.7208 16.7325 10.8798 16.6667 11.0456 16.6667H15.6306C15.9067 16.6667 16.1715 16.557 16.3668 16.3619C16.5622 16.1667 16.672 15.902 16.6722 15.6258L16.6747 13.1242ZM1.25391 4.7925C1.25369 4.95826 1.18763 5.11714 1.07026 5.2342C0.952893 5.35125 0.793834 5.41689 0.628073 5.41667C0.462313 5.41645 0.30343 5.35039 0.186376 5.23302C0.0693218 5.11565 0.0036858 4.95659 0.00390681 4.79083L0.00640682 2.28917C0.00706939 1.68181 0.248805 1.09956 0.678504 0.67033C1.1082 0.241099 1.69072 -3.61401e-07 2.29807 0H8.54557C8.71134 0 8.87031 0.065848 8.98752 0.183058C9.10473 0.300269 9.17057 0.45924 9.17057 0.625C9.17057 0.79076 9.10473 0.949732 8.98752 1.06694C8.87031 1.18415 8.71134 1.25 8.54557 1.25H2.29807C2.02195 1.25 1.75713 1.35963 1.5618 1.5548C1.36647 1.74997 1.25663 2.01471 1.25641 2.29083L1.25391 4.7925Z"
        fill={fill}
        fillOpacity={0.8}
      />
    </svg>
  );
};


export const FilledConnectionsIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4.60767 12.374C6.17514 12.374 7.44582 11.1034 7.44582 9.5359C7.44582 7.96843 6.17514 6.69775 4.60767 6.69775C3.04021 6.69775 1.76953 7.96843 1.76953 9.5359C1.76953 11.1034 3.04021 12.374 4.60767 12.374Z"
        fill={fill}
      />

      <path
        d="M13.4006 5.67629C14.9681 5.67629 16.2388 4.40561 16.2388 2.83814C16.2388 1.27068 14.9681 0 13.4006 0C11.8332 0 10.5625 1.27068 10.5625 2.83814C10.5625 4.40561 11.8332 5.67629 13.4006 5.67629Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7526 13.1852C16.7526 12.8386 17.0347 12.5582 17.3805 12.5582C17.7271 12.5582 18.0084 12.8403 18.0084 13.1869L18.0059 15.7002C18.0042 16.9703 16.9744 18 15.7035 18H11.0972C10.7506 18 10.4693 17.7187 10.4693 17.3721C10.4693 17.0255 10.7506 16.7442 11.0972 16.7442H15.7035C16.2812 16.7442 16.7492 16.2762 16.7501 15.6985L16.7526 13.1852ZM1.26002 4.81481C1.26002 5.16142 0.977894 5.4419 0.631289 5.4419C0.284684 5.4419 0.00420247 5.15978 0.00420247 4.81317L0.00673051 2.29987C0.00755131 1.02977 1.03814 0 2.30903 0H8.58558C8.93218 0 9.21348 0.281303 9.21348 0.627908C9.21348 0.974513 8.93218 1.25582 8.58558 1.25582H2.30903C1.73135 1.25582 1.26337 1.7238 1.26251 2.30151L1.26002 4.81481ZM7.32644 12.0073C8.47007 12.8462 9.21352 14.1999 9.21352 15.7253C9.21352 16.3775 8.80243 16.946 8.04644 17.337C7.21176 17.769 5.91074 18 4.60718 18C3.30281 18 2.00179 17.769 1.16707 17.337C0.411087 16.946 0 16.3775 0 15.7253C0 14.1999 0.743443 12.8462 1.88707 12.0073C2.56019 12.7474 3.52968 13.2112 4.60718 13.2112C5.68384 13.2112 6.65415 12.7474 7.32644 12.0073ZM16.1213 5.30959C17.265 6.14847 18.0084 7.50226 18.0084 9.02762C18.0084 9.67982 17.5973 10.2483 16.8413 10.6392C16.0066 11.0712 14.7056 11.3023 13.4012 11.3023C12.0977 11.3023 10.7966 11.0712 9.96195 10.6392C9.20597 10.2483 8.79488 9.67979 8.79488 9.02762C8.79488 7.50222 9.53832 6.14844 10.6819 5.30959C11.3542 6.04968 12.3246 6.5135 13.4012 6.5135C14.4787 6.5135 15.4482 6.04968 16.1213 5.30959Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChatIcon: React.FC<IconProps> = ({
  size = 20,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M19.928 15.5403L18.7664 12.1597C19.3263 11.0151 19.6222 9.74215 19.6242 8.46133C19.6276 6.23426 18.766 4.12851 17.1979 2.53203C15.6296 0.935234 13.5397 0.0363662 11.3131 0.00109273C9.0043 -0.0353916 6.83415 0.842811 5.20262 2.4743C3.62942 4.04746 2.75684 6.12141 2.72922 8.33766C1.17868 9.50508 0.263482 11.3252 0.266489 13.2693C0.267935 14.1791 0.4727 15.0834 0.860708 15.9012L0.0605909 18.2296C-0.0769481 18.6299 0.0235206 19.0645 0.322818 19.3638C0.533442 19.5745 0.811138 19.6866 1.09672 19.6866C1.21688 19.6866 1.33844 19.6668 1.457 19.626L3.78547 18.8259C4.60325 19.2139 5.50758 19.4187 6.41735 19.4201H6.42704C8.40008 19.42 10.2341 18.4812 11.3972 16.8927C12.6077 16.8608 13.8053 16.5678 14.888 16.0382L18.2686 17.1998C18.4063 17.2473 18.551 17.2717 18.6967 17.2718C19.0361 17.2718 19.3661 17.1385 19.6164 16.8881C19.972 16.5325 20.0914 16.016 19.928 15.5403ZM6.42696 18.2296H6.41918C5.61395 18.2284 4.8143 18.0299 4.10684 17.6556C4.03489 17.6176 3.9559 17.5947 3.87476 17.5883C3.79361 17.582 3.71202 17.5924 3.63504 17.6188L1.24743 18.4393L2.06786 16.0517C2.0943 15.9747 2.10468 15.8931 2.09835 15.812C2.09202 15.7308 2.06912 15.6518 2.03106 15.5799C1.65676 14.8724 1.45825 14.0728 1.457 13.2675C1.455 11.9722 1.95887 10.7445 2.84001 9.82523C3.12782 11.5798 3.96403 13.1966 5.2602 14.4697C6.5468 15.7334 8.16407 16.538 9.90907 16.8011C8.98766 17.7092 7.74563 18.2296 6.42696 18.2296ZM18.7745 16.0463C18.7407 16.0802 18.7005 16.0894 18.6554 16.0739L15.0363 14.8303C14.9593 14.8038 14.8777 14.7934 14.7966 14.7997C14.7155 14.8061 14.6365 14.829 14.5645 14.8671C13.5312 15.4137 12.3636 15.7036 11.1877 15.7054H11.1765C7.23649 15.7054 3.98208 12.5049 3.91965 8.56586C3.88821 6.58207 4.64282 4.71766 6.04442 3.31605C7.44602 1.91445 9.31075 1.16012 11.2943 1.19137C15.2371 1.25391 18.4398 4.51433 18.4337 8.45945C18.4319 9.63531 18.142 10.803 17.5954 11.8363C17.5573 11.9082 17.5344 11.9872 17.5281 12.0683C17.5218 12.1495 17.5322 12.2311 17.5586 12.308L18.8022 15.9271C18.8177 15.9724 18.8084 16.0125 18.7745 16.0463Z"
        fill={fill}
        fillOpacity={0.8}
      />

      <path
        d="M14.7226 5.29297H7.63043C7.30168 5.29297 7.03519 5.55949 7.03519 5.8882C7.03519 6.21695 7.30172 6.48344 7.63043 6.48344H14.7226C15.0514 6.48344 15.3179 6.21691 15.3179 5.8882C15.3179 5.55949 15.0514 5.29297 14.7226 5.29297ZM14.7226 7.74106H7.63043C7.30168 7.74106 7.03519 8.00758 7.03519 8.33629C7.03519 8.665 7.30172 8.93152 7.63043 8.93152H14.7226C15.0514 8.93152 15.3179 8.665 15.3179 8.33629C15.3179 8.00758 15.0514 7.74106 14.7226 7.74106ZM11.9926 10.1891H7.63039C7.30164 10.1891 7.03516 10.4556 7.03516 10.7843C7.03516 11.113 7.30168 11.3795 7.63039 11.3795H11.9926C12.3213 11.3795 12.5878 11.113 12.5878 10.7843C12.5878 10.4556 12.3214 10.1891 11.9926 10.1891Z"
        fill={fill}
        fillOpacity={0.8}
      />
    </svg>
  );
};

export const FilledChatIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4.04673 14.0064C2.56792 12.5539 1.66371 10.6717 1.45377 8.64136C0.667815 9.63489 0.241656 10.8535 0.243621 12.1324C0.244942 12.9642 0.432163 13.791 0.786927 14.5388L0.0553995 16.6677C-0.0703552 17.0336 0.0215054 17.431 0.295158 17.7047C0.487737 17.8973 0.741639 17.9998 1.00276 17.9998C1.11262 17.9998 1.22376 17.9817 1.33216 17.9445L3.46113 17.2129C4.20884 17.5677 5.03569 17.7549 5.86751 17.7562C7.17145 17.7579 8.41246 17.3155 9.41625 16.5001C7.39789 16.3175 5.51507 15.4486 4.04673 14.0064Z"
        fill={fill}
      />

      <path
        d="M18.2222 14.2088L17.1601 11.1179C17.6721 10.0713 17.9426 8.90744 17.9444 7.73636C17.9476 5.7001 17.1597 3.77478 15.7261 2.31509C14.2921 0.855068 12.3812 0.0332524 10.3454 0.0010012C8.23445 -0.0323929 6.25024 0.770565 4.7585 2.26226C3.26677 3.75396 2.46367 5.73818 2.4971 7.84926C2.52935 9.88501 3.35116 11.7959 4.81111 13.2299C6.26795 14.6608 8.18838 15.4484 10.2203 15.4483H10.2324C11.4035 15.4465 12.5674 15.176 13.614 14.664L16.7049 15.7261C16.8309 15.7696 16.9631 15.7918 17.0964 15.7919C17.4066 15.7919 17.7084 15.6701 17.9373 15.4411C18.2625 15.1159 18.3716 14.6438 18.2222 14.2088ZM10.9665 10.4046H6.97801C6.67743 10.4046 6.43378 10.1609 6.43378 9.86033C6.43378 9.55975 6.67747 9.3161 6.97801 9.3161H10.9664C11.267 9.3161 11.5107 9.55978 11.5107 9.86033C11.5107 10.1609 11.2671 10.4046 10.9665 10.4046ZM13.4626 8.1663H6.97805C6.67747 8.1663 6.43381 7.92262 6.43381 7.62207C6.43381 7.32152 6.6775 7.07783 6.97805 7.07783H13.4626C13.7632 7.07783 14.0068 7.32152 14.0068 7.62207C14.0068 7.92262 13.7632 8.1663 13.4626 8.1663ZM13.4626 5.92797H6.97805C6.67747 5.92797 6.43381 5.68428 6.43381 5.38374C6.43381 5.08315 6.6775 4.8395 6.97805 4.8395H13.4626C13.7632 4.8395 14.0068 5.08319 14.0068 5.38374C14.0068 5.68428 13.7632 5.92797 13.4626 5.92797Z"
        fill={fill}
      />
    </svg>
  );
};

export const BillingHistoryIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={14}
      height={size}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1725 0.545625C9.82111 0.196109 9.34562 -6.18614e-05 8.85 1.46332e-08H1.875C1.37772 1.46332e-08 0.900806 0.197544 0.549175 0.549175C0.197544 0.900806 0 1.37772 0 1.875V14.5881C5.52693e-05 14.9416 0.100001 15.2878 0.288312 15.5869C0.476623 15.8859 0.74563 16.1257 1.06432 16.2785C1.383 16.4313 1.73839 16.491 2.0895 16.4505C2.44061 16.4101 2.77314 16.2712 3.04875 16.05L3.35875 15.8013C3.4697 15.7122 3.60772 15.6636 3.75 15.6636C3.89228 15.6636 4.0303 15.7122 4.14125 15.8013L5.7025 17.055C6.03499 17.322 6.44856 17.4677 6.87498 17.468C7.30141 17.4684 7.71521 17.3233 8.04813 17.0569L9.61063 15.8069C9.7213 15.7183 9.85879 15.6701 10.0005 15.67C10.1422 15.6698 10.2798 15.7179 10.3906 15.8062L10.7144 16.0644C10.9903 16.2845 11.3227 16.4223 11.6735 16.4619C12.0242 16.5015 12.379 16.4412 12.6971 16.2881C13.0151 16.135 13.2835 15.8952 13.4713 15.5964C13.6591 15.2975 13.7587 14.9517 13.7587 14.5988V4.8925C13.7587 4.39375 13.56 3.91563 13.2062 3.56375L10.1725 0.545625ZM8.125 1.25H1.875C1.70924 1.25 1.55027 1.31585 1.43306 1.43306C1.31585 1.55027 1.25 1.70924 1.25 1.875V14.5881C1.25022 14.7058 1.28366 14.8211 1.34646 14.9207C1.40927 15.0203 1.49889 15.1001 1.60503 15.151C1.71117 15.2019 1.82953 15.2219 1.9465 15.2085C2.06346 15.1952 2.17429 15.1491 2.26625 15.0756L2.57625 14.8269C2.90911 14.5597 3.32317 14.414 3.75 14.414C4.17683 14.414 4.59089 14.5597 4.92375 14.8269L6.485 16.0806C6.71313 16.2638 7.03813 16.2638 7.26688 16.0812L8.82938 14.8306C9.16152 14.5647 9.57421 14.4197 9.99967 14.4194C10.4251 14.419 10.8381 14.5634 11.1706 14.8288L11.4944 15.0869C11.5863 15.1601 11.6971 15.2059 11.8139 15.2191C11.9307 15.2322 12.0488 15.2121 12.1548 15.1612C12.2607 15.1102 12.3501 15.0304 12.4127 14.9309C12.4753 14.8314 12.5086 14.7163 12.5087 14.5988V5.62312H10C9.50276 5.62302 9.02592 5.42541 8.67437 5.07375C8.32272 4.7222 8.12511 4.24537 8.125 3.74813V1.25ZM8.58812 13.5438L10.4419 11.69C10.5293 11.6026 10.5888 11.4912 10.6129 11.37C10.637 11.2488 10.6246 11.1232 10.5773 11.009C10.53 10.8948 10.4499 10.7972 10.3472 10.7285C10.2444 10.6598 10.1236 10.6232 10 10.6231H3.75C3.58424 10.6231 3.42527 10.689 3.30806 10.8062C3.19085 10.9234 3.125 11.0824 3.125 11.2481C3.125 11.4139 3.19085 11.5729 3.30806 11.6901C3.42527 11.8073 3.58424 11.8731 3.75 11.8731H8.49125L7.70437 12.66C7.64635 12.718 7.60032 12.7869 7.56891 12.8627C7.53751 12.9386 7.52134 13.0198 7.52134 13.1019C7.52134 13.1839 7.53751 13.2652 7.56891 13.341C7.60032 13.4168 7.64635 13.4857 7.70437 13.5438C7.7624 13.6018 7.83129 13.6478 7.90711 13.6792C7.98293 13.7106 8.06419 13.7268 8.14625 13.7268C8.22831 13.7268 8.30957 13.7106 8.38539 13.6792C8.46121 13.6478 8.5301 13.6018 8.58812 13.5438ZM5.16187 6.4525L3.30813 8.30625C3.22074 8.39366 3.16124 8.50501 3.13714 8.62623C3.11303 8.74745 3.12541 8.8731 3.1727 8.98728C3.21999 9.10147 3.30008 9.19907 3.40284 9.26775C3.50559 9.33643 3.62641 9.3731 3.75 9.37313H10C10.1658 9.37313 10.3247 9.30728 10.4419 9.19007C10.5592 9.07286 10.625 8.91389 10.625 8.74813C10.625 8.58237 10.5592 8.42339 10.4419 8.30618C10.3247 8.18897 10.1658 8.12313 10 8.12313H5.25875L6.04563 7.33625C6.16282 7.21906 6.22866 7.06011 6.22866 6.89438C6.22866 6.72864 6.16282 6.56969 6.04563 6.4525C5.92843 6.33531 5.76948 6.26947 5.60375 6.26947C5.43801 6.26947 5.27907 6.33531 5.16187 6.4525ZM9.375 1.515V3.74813C9.37475 3.83027 9.39075 3.91165 9.42207 3.9876C9.45339 4.06354 9.49942 4.13253 9.55751 4.19062C9.61559 4.2487 9.68459 4.29473 9.76053 4.32605C9.83647 4.35738 9.91785 4.37337 10 4.37313H12.2475L9.375 1.515Z"
        fill={fill}
        fillOpacity={0.8}
      />
    </svg>
  );
};
export const FilledBillingHistoryIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={15}
      height={19}
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.38737 0H1.93555C1.42221 0 0.929894 0.203923 0.566908 0.566908C0.203923 0.929894 0 1.42221 0 1.93555V15.0592C5.7054e-05 15.424 0.10323 15.7814 0.297621 16.0902C0.492013 16.3989 0.769708 16.6464 1.09868 16.8042C1.42766 16.9619 1.79452 17.0235 2.15697 16.9817C2.51942 16.94 2.86269 16.7967 3.1472 16.5683L3.46721 16.3115C3.58174 16.2195 3.72422 16.1694 3.87109 16.1694C4.01796 16.1694 4.16044 16.2195 4.27498 16.3115L5.88664 17.6057C6.22987 17.8813 6.65679 18.0317 7.09698 18.0321C7.53718 18.0324 7.96434 17.8827 8.30801 17.6077L9.92096 16.3173C10.0352 16.2259 10.1771 16.1761 10.3234 16.176C10.4697 16.1758 10.6118 16.2254 10.7261 16.3167L11.0604 16.5831C11.3452 16.8104 11.6884 16.9526 12.0504 16.9935C12.4125 17.0343 12.7788 16.9721 13.1071 16.8141C13.4354 16.656 13.7124 16.4085 13.9063 16.1C14.1002 15.7915 14.203 15.4345 14.203 15.0702V5.8047H10.3229C9.80961 5.80459 9.31738 5.6006 8.95448 5.23759C8.59147 4.87469 8.38748 4.38245 8.38737 3.86916V0ZM8.86545 13.9811L10.7791 12.0675C10.8693 11.9773 10.9307 11.8623 10.9556 11.7372C10.9804 11.612 10.9677 11.4823 10.9189 11.3645C10.87 11.2466 10.7874 11.1458 10.6813 11.0749C10.5752 11.004 10.4505 10.9662 10.3229 10.9662H3.87109C3.69998 10.9662 3.53587 11.0341 3.41488 11.1551C3.29388 11.2761 3.22591 11.4402 3.22591 11.6113C3.22591 11.7825 3.29388 11.9466 3.41488 12.0676C3.53587 12.1885 3.69998 12.2565 3.87109 12.2565H8.76544L7.95316 13.0688C7.89326 13.1287 7.84574 13.1998 7.81332 13.2781C7.7809 13.3564 7.76422 13.4402 7.76422 13.525C7.76422 13.6097 7.7809 13.6935 7.81332 13.7718C7.84574 13.8501 7.89326 13.9212 7.95316 13.9811C8.01306 14.041 8.08417 14.0885 8.16244 14.1209C8.2407 14.1533 8.32459 14.17 8.4093 14.17C8.49402 14.17 8.5779 14.1533 8.65617 14.1209C8.73443 14.0885 8.80554 14.041 8.86545 13.9811ZM5.32856 6.66086L3.41495 8.57447C3.32475 8.6647 3.26332 8.77965 3.23844 8.90478C3.21355 9.02992 3.22633 9.15962 3.27515 9.27749C3.32397 9.39537 3.40665 9.49612 3.51272 9.56702C3.61879 9.63791 3.74351 9.67577 3.87109 9.67579H10.3229C10.494 9.67579 10.6581 9.60782 10.7791 9.48683C10.9001 9.36583 10.9681 9.20173 10.9681 9.03061C10.9681 8.8595 10.9001 8.6954 10.7791 8.5744C10.6581 8.45341 10.494 8.38543 10.3229 8.38543H5.42856L6.24085 7.57315C6.36182 7.45217 6.42979 7.28809 6.42979 7.117C6.42979 6.94592 6.36182 6.78184 6.24085 6.66086C6.11987 6.53988 5.95579 6.47192 5.7847 6.47192C5.61361 6.47192 5.44953 6.53988 5.32856 6.66086ZM9.67773 0.0774218V3.86916C9.67747 3.95395 9.69399 4.03797 9.72632 4.11636C9.75865 4.19475 9.80617 4.26598 9.86613 4.32594C9.92609 4.3859 9.99732 4.43341 10.0757 4.46575C10.1541 4.49808 10.2381 4.51459 10.3229 4.51434H14.1275C14.0363 4.19831 13.866 3.91076 13.6327 3.67883L10.501 0.563244C10.2715 0.335021 9.98845 0.167986 9.67773 0.0774218Z"
        fill={fill}
      />
    </svg>
  );
};
export const CompanyIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.75 7.11505C3.75 6.94929 3.81585 6.79032 3.93306 6.67311C4.05027 6.5559 4.20924 6.49005 4.375 6.49005H8.125C8.29076 6.49005 8.44973 6.5559 8.56694 6.67311C8.68415 6.79032 8.75 6.94929 8.75 7.11505C8.75 7.28081 8.68415 7.43978 8.56694 7.55699C8.44973 7.6742 8.29076 7.74005 8.125 7.74005H4.375C4.20924 7.74005 4.05027 7.6742 3.93306 7.55699C3.81585 7.43978 3.75 7.28081 3.75 7.11505ZM8.125 8.99005H4.375C4.20924 8.99005 4.05027 9.0559 3.93306 9.17311C3.81585 9.29032 3.75 9.44929 3.75 9.61505C3.75 9.78081 3.81585 9.93978 3.93306 10.057C4.05027 10.1742 4.20924 10.24 4.375 10.24H8.125C8.29076 10.24 8.44973 10.1742 8.56694 10.057C8.68415 9.93978 8.75 9.78081 8.75 9.61505C8.75 9.44929 8.68415 9.29032 8.56694 9.17311C8.44973 9.0559 8.29076 8.99005 8.125 8.99005ZM8.125 11.49H4.375C4.20924 11.49 4.05027 11.5559 3.93306 11.6731C3.81585 11.7903 3.75 11.9493 3.75 12.115C3.75 12.2808 3.81585 12.4398 3.93306 12.557C4.05027 12.6742 4.20924 12.74 4.375 12.74H8.125C8.29076 12.74 8.44973 12.6742 8.56694 12.557C8.68415 12.4398 8.75 12.2808 8.75 12.115C8.75 11.9493 8.68415 11.7903 8.56694 11.6731C8.44973 11.5559 8.29076 11.49 8.125 11.49ZM8.125 13.99H4.375C4.20924 13.99 4.05027 14.0559 3.93306 14.1731C3.81585 14.2903 3.75 14.4493 3.75 14.615C3.75 14.7808 3.81585 14.9398 3.93306 15.057C4.05027 15.1742 4.20924 15.24 4.375 15.24H8.125C8.29076 15.24 8.44973 15.1742 8.56694 15.057C8.68415 14.9398 8.75 14.7808 8.75 14.615C8.75 14.4493 8.68415 14.2903 8.56694 14.1731C8.44973 14.0559 8.29076 13.99 8.125 13.99ZM17.5 17.115C17.5 17.2808 17.4342 17.4398 17.3169 17.557C17.1997 17.6742 17.0408 17.74 16.875 17.74H0.625C0.45924 17.74 0.300268 17.6742 0.183058 17.557C0.065848 17.4398 0 17.2808 0 17.115C0 16.9493 0.065848 16.7903 0.183058 16.6731C0.300268 16.5559 0.45924 16.49 0.625 16.49H1.25V5.0013C1.24923 4.76903 1.31351 4.54118 1.43557 4.34357C1.55763 4.14596 1.73259 3.98647 1.94062 3.88317L9.44062 0.133175C9.83187 -0.0618253 10.2856 -0.0418253 10.6569 0.18755C11.0281 0.416925 11.2494 0.814425 11.2494 1.2513V5.86505H14.9994C15.6888 5.86505 16.2494 6.42567 16.2494 7.11505V16.49H16.8744C17.0401 16.49 17.1991 16.5559 17.3163 16.6731C17.4335 16.7903 17.5 16.9493 17.5 17.115ZM11.25 7.11505V16.49H15V7.11505H11.25ZM2.5 16.49H10V1.2513L2.5 5.0013V16.49Z"
        fill={fill}
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const FilledCompanyIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={15}
      height={size}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00897 0C9.20632 0.00236835 9.39478 0.0824302 9.5335 0.222826C9.67221 0.363222 9.74999 0.552636 9.74997 0.749998V17.25C9.74999 17.4472 9.67231 17.6365 9.53376 17.7769C9.39521 17.9172 9.20694 17.9974 9.00973 18H0.749998C0.551086 18 0.360321 17.9209 0.219669 17.7803C0.0790176 17.6396 3.59823e-08 17.4489 3.59823e-08 17.25V4.80074C-8.25588e-05 4.33878 0.14203 3.888 0.407034 3.50961C0.672038 3.13122 1.04709 2.84358 1.48125 2.68574L8.74348 0.0449998C8.82348 0.0164999 8.90448 0.0015 8.98647 0H8.99772H9.00897ZM11.25 6.14848L13.6365 7.17073C14.0412 7.34424 14.3862 7.63272 14.6285 8.00041C14.8709 8.3681 15.0001 8.79884 15 9.23922V17.25C15 17.4489 14.9209 17.6396 14.7803 17.7803C14.6396 17.9209 14.4489 18 14.25 18H11.1217C11.205 17.7652 11.25 17.5132 11.25 17.25V6.14848ZM6.00973 12.75C6.10822 12.7493 6.20562 12.7293 6.29637 12.691C6.38712 12.6527 6.46944 12.5969 6.53863 12.5268C6.60782 12.4568 6.66253 12.3737 6.69963 12.2825C6.73673 12.1912 6.7555 12.0936 6.75486 11.9951C6.75422 11.8966 6.73418 11.7992 6.6959 11.7085C6.65762 11.6177 6.60184 11.5354 6.53174 11.4662C6.46164 11.397 6.3786 11.3423 6.28737 11.3052C6.19613 11.2681 6.09847 11.2493 5.99998 11.25H3.74999C3.55108 11.25 3.36031 11.329 3.21966 11.4696C3.07901 11.6103 2.99999 11.8011 2.99999 12C2.99999 12.1989 3.07901 12.3896 3.21966 12.5303C3.36031 12.6709 3.55108 12.75 3.74999 12.75H5.99998H6.00973ZM6.00973 9.74997C6.20864 9.74868 6.3989 9.66842 6.53863 9.52686C6.67837 9.38529 6.75615 9.19401 6.75486 8.9951C6.75356 8.79619 6.67331 8.60594 6.53174 8.4662C6.39017 8.32646 6.19889 8.24868 5.99998 8.24998H3.74999C3.55108 8.24998 3.36031 8.32899 3.21966 8.46965C3.07901 8.6103 2.99999 8.80106 2.99999 8.99998C2.99999 9.19889 3.07901 9.38965 3.21966 9.5303C3.36031 9.67096 3.55108 9.74997 3.74999 9.74997H5.99998H6.00973ZM6.00973 6.74998C6.20864 6.74869 6.3989 6.66843 6.53863 6.52687C6.67837 6.3853 6.75615 6.19402 6.75486 5.99511C6.75356 5.7962 6.67331 5.60595 6.53174 5.46621C6.39017 5.32647 6.19889 5.24869 5.99998 5.24999H3.74999C3.55108 5.24999 3.36031 5.329 3.21966 5.46966C3.07901 5.61031 2.99999 5.80107 2.99999 5.99998C2.99999 6.19889 3.07901 6.38966 3.21966 6.53031C3.36031 6.67096 3.55108 6.74998 3.74999 6.74998H5.99998H6.00973Z"
        fill={fill}
      />
    </svg>
  );
};
export const JobsIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  stroke = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.4727 4.77999V16.3816H0.527344V4.77999"
        stroke={stroke}
        strokeOpacity={0.8}
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M7.94534 10.0535H4.62274C4.04727 10.0535 0.527344 10.1231 0.527344 4.78006C0.527344 4.19759 0.999564 3.72537 1.58203 3.72537H16.418C17.0005 3.72537 17.4727 4.19759 17.4727 4.78006C17.4727 10.1905 13.9304 10.0535 13.3773 10.0535H10.0547"
        stroke={stroke}
        strokeOpacity={0.8}
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M10.0547 12.1628H7.94531V8.99877H10.0547V12.1628Z"
        stroke={stroke}
        strokeOpacity={0.8}
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M5.83594 3.72534V2.67065C5.83594 2.08818 6.30816 1.61596 6.89063 1.61596H11.1094C11.6919 1.61596 12.1641 2.08818 12.1641 2.67065V3.72534"
        stroke={stroke}
        strokeOpacity={0.8}
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FilledJobsIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={19}
      height={16}
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.63516 11.2C9.92966 11.2 10.1685 10.9612 10.1685 10.6667V8.53333C10.1685 8.23883 9.92977 8 9.63516 8H8.56849C8.27398 8 8.03516 8.23872 8.03516 8.53333V10.6667C8.03516 10.9612 8.27395 11.2 8.56849 11.2H9.63516Z"
        fill={fill}
      />

      <path
        d="M16.6044 2.13333H12.8356V1.6C12.8356 0.717724 12.1179 0 11.2356 0H6.96889C6.08661 0 5.36889 0.717689 5.36889 1.6V2.13333H1.6C0.717725 2.13333 0 2.85102 0 3.73333C0 4.77785 0.128 5.69259 0.382151 6.47214C0.636302 7.2517 1.01664 7.89611 1.52135 8.4C2.37067 9.24818 3.45248 9.6 4.6672 9.6H6.96889V8.53333C6.96889 7.65106 7.68658 6.93333 8.56889 6.93333H9.63556C10.5178 6.93333 11.2356 7.65102 11.2356 8.53333V9.6H12.4206C13.4823 9.55587 15.2189 9.87872 16.6826 8.42187C17.1875 7.91925 17.568 7.27371 17.8222 6.49049C18.0765 5.70727 18.2044 4.78645 18.2044 3.73333C18.2044 2.85106 17.4868 2.13333 16.6044 2.13333ZM6.43556 1.6C6.43556 1.30574 6.6746 1.06667 6.96889 1.06667H11.2356C11.5298 1.06667 11.7689 1.30571 11.7689 1.6V2.13333H6.43556V1.6Z"
        fill={fill}
      />

      <path
        d="M12.4352 10.6666H11.2356C11.2356 11.5489 10.5179 12.2666 9.63556 12.2666H8.56889C7.68661 12.2666 6.96889 11.5489 6.96889 10.6666H4.67186C3.15065 10.6666 1.81451 10.1998 0.76768 9.15466C0.471964 8.85944 0.219449 8.52703 0 8.17151V15.4666C0 15.7614 0.238542 16 0.533333 16H17.6711C17.9659 16 18.2044 15.7614 18.2044 15.4666V8.19345C17.982 8.55437 17.7285 8.886 17.4352 9.17809C15.7523 10.8521 13.9601 10.5946 12.4352 10.6666Z"
        fill={fill}
      />
    </svg>
  );
};


export const BusinessVerificationIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.27384 17.9373C9.10062 18.0209 8.89946 18.0209 8.72622 17.9373C2.05653 14.7463 0.17193 9.64125 0.000268048 3.84584C-0.00931151 3.50915 0.23896 3.22228 0.571045 3.18692C2.29055 3.0037 3.73944 1.9012 4.42506 0.377672C4.52804 0.147847 4.75635 0 5.00702 0H12.993C13.2437 0 13.472 0.147858 13.5749 0.377672C14.2607 1.90124 15.7095 3.00383 17.429 3.18692C17.761 3.22227 18.0093 3.50915 17.9997 3.84584C17.8281 9.64125 15.9435 14.7463 9.27384 17.9373ZM9.00004 16.6428C14.6949 13.807 16.4432 9.38719 16.7003 4.37227C14.9249 4.00021 13.4338 2.84627 12.5972 1.28572H5.40311C4.5665 2.84625 3.07443 4.00013 1.29998 4.37227C1.55702 9.38739 3.30525 13.807 9.00025 16.6428H9.00004ZM5.6745 9.13334C5.42542 8.88261 5.42542 8.47441 5.6745 8.22368C5.92357 7.97296 6.32908 7.97296 6.57816 8.22368L8.33038 9.98833L12.3514 5.36221C12.5837 5.09542 12.9868 5.0681 13.2526 5.30194C13.5177 5.53578 13.5448 5.94159 13.3125 6.20918L8.84213 11.3521C8.72558 11.4863 8.55954 11.565 8.38232 11.5706C8.2067 11.5771 8.03507 11.5088 7.90974 11.3834L5.6745 9.13334Z"
        fill={fill}
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const FilledBusinessVerificationIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.27384 17.9373C9.10062 18.0209 8.89946 18.0209 8.72622 17.9373C2.05653 14.7463 0.17193 9.64125 0.000268048 3.84584C-0.00931151 3.50915 0.23896 3.22228 0.571045 3.18692C2.29055 3.0037 3.73944 1.9012 4.42506 0.377672C4.52804 0.147847 4.75635 0 5.00702 0H12.993C13.2437 0 13.472 0.147858 13.5749 0.377672C14.2607 1.90124 15.7095 3.00383 17.429 3.18692C17.761 3.22227 18.0093 3.50915 17.9997 3.84584C17.8281 9.64125 15.9435 14.7463 9.27384 17.9373ZM5.67446 9.13334L7.90974 11.3834C8.03507 11.5088 8.2067 11.5771 8.38232 11.5707C8.55954 11.5651 8.72559 11.4863 8.84213 11.3521L13.3125 6.20923C13.5448 5.94164 13.5177 5.53584 13.2526 5.30199C12.9868 5.06815 12.5837 5.09547 12.3514 5.36226L8.33038 9.98837L6.57816 8.22373C6.32909 7.97301 5.92358 7.97301 5.6745 8.22373C5.42543 8.47446 5.42538 8.88261 5.67446 9.13334Z"
        fill={fill}
      />
    </svg>
  );
};
export const SettingsIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.6946 2.43561C11.3084 2.59409 11.8969 2.83835 12.4425 3.16117L12.994 2.60957C13.0989 2.5046 13.2235 2.42134 13.3606 2.36454C13.4977 2.30775 13.6446 2.27853 13.793 2.27857C13.9414 2.27858 14.0883 2.30781 14.2253 2.36461C14.3623 2.4214 14.4869 2.50464 14.5917 2.60957L15.3904 3.40828C15.4954 3.51312 15.5786 3.63762 15.6354 3.77467C15.6922 3.91172 15.7214 4.05862 15.7214 4.20697C15.7214 4.35536 15.6922 4.50231 15.6354 4.6394C15.5786 4.7765 15.4954 4.90105 15.3904 5.00593L14.8388 5.5575C15.1617 6.10314 15.4059 6.69158 15.5644 7.30544H16.343C16.9669 7.30544 17.4727 7.81127 17.4727 8.43512V9.56483C17.4727 10.1887 16.9669 10.6945 16.343 10.6945H15.5644C15.4059 11.3084 15.1616 11.8968 14.8388 12.4424L15.3904 12.994C15.4954 13.0989 15.5786 13.2234 15.6354 13.3605C15.6922 13.4976 15.7214 13.6446 15.7214 13.793C15.7214 13.9413 15.6922 14.0882 15.6354 14.2253C15.5786 14.3623 15.4954 14.4868 15.3904 14.5917L14.5917 15.3903C14.4869 15.4953 14.3624 15.5786 14.2253 15.6354C14.0883 15.6922 13.9414 15.7214 13.793 15.7213C13.6446 15.7214 13.4977 15.6922 13.3606 15.6354C13.2235 15.5786 13.0989 15.4953 12.994 15.3903L12.4425 14.8388C11.8969 15.1616 11.3084 15.4058 10.6946 15.5643V16.3429C10.6946 16.9668 10.1887 17.4727 9.56485 17.4727H8.43517C7.81129 17.4727 7.30549 16.9668 7.30549 16.3429V15.5643C6.69163 15.4058 6.10319 15.1616 5.55755 14.8388L5.00598 15.3903C4.90109 15.4953 4.77654 15.5786 4.63944 15.6354C4.50235 15.6922 4.35541 15.7214 4.20702 15.7213C4.05867 15.7214 3.91177 15.6922 3.77473 15.6354C3.63768 15.5786 3.51318 15.4953 3.40834 15.3903L2.60962 14.5917C2.50468 14.4868 2.42143 14.3623 2.36463 14.2253C2.30784 14.0882 2.27861 13.9413 2.27862 13.793C2.27859 13.6446 2.3078 13.4976 2.3646 13.3605C2.42139 13.2234 2.50465 13.0989 2.60962 12.994L3.16122 12.4424C2.8384 11.8968 2.59415 11.3084 2.43567 10.6945H1.65706C1.03317 10.6945 0.527344 10.1887 0.527344 9.56483V8.43512C0.527344 7.81127 1.03317 7.30544 1.65706 7.30544H2.43567C2.59414 6.69158 2.8384 6.10314 3.16122 5.5575L2.60962 5.00593C2.50466 4.90103 2.4214 4.77648 2.36461 4.63939C2.30781 4.5023 2.27859 4.35536 2.27862 4.20697C2.27861 4.05862 2.30784 3.91173 2.36463 3.77468C2.42143 3.63764 2.50468 3.51313 2.60962 3.40828L3.40834 2.60957C3.51318 2.50461 3.63768 2.42135 3.77473 2.36455C3.91177 2.30776 4.05867 2.27854 4.20702 2.27857C4.35541 2.27854 4.50235 2.30776 4.63944 2.36455C4.77654 2.42135 4.90109 2.5046 5.00598 2.60957L5.55755 3.16117C6.10319 2.83835 6.69163 2.59409 7.30549 2.43561V1.65697C7.30549 1.03308 7.81129 0.52729 8.43517 0.52729H9.56485C10.1887 0.52729 10.6946 1.03308 10.6946 1.65697V2.43561Z"
        stroke={fill}
        strokeOpacity="0.8"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99845 5.61089C10.8689 5.61089 12.3875 7.12947 12.3875 8.99996C12.3875 10.8704 10.8689 12.389 8.99845 12.389C7.12795 12.389 5.60938 10.8704 5.60938 8.99996C5.60938 7.12951 7.12795 5.61089 8.99845 5.61089Z"
        stroke={fill}
        strokeOpacity="0.8"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilledSettingsIcon: React.FC<IconProps> = ({
  size = 20,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_1458_384)">
        <path
          d="M18.1588 7.53125H17.7342C17.5962 7.09947 17.4221 6.68006 17.2138 6.27746L17.5145 5.97676C18.2436 5.24844 18.2241 4.08125 17.5147 3.37266L16.6276 2.48555C15.9194 1.77645 14.752 1.7559 14.0235 2.48527L13.7225 2.78621C13.3199 2.5779 12.9005 2.40381 12.4688 2.26578V1.84113C12.4688 0.825937 11.6428 0 10.6276 0H9.37238C8.35719 0 7.53125 0.825937 7.53125 1.84113V2.26578C7.09945 2.40375 6.68004 2.57785 6.27746 2.78621L5.9768 2.48555C5.24973 1.75762 4.08234 1.77469 3.37273 2.48531L2.48551 3.37246C1.77645 4.08074 1.75594 5.24801 2.48527 5.97656L2.78621 6.2775C2.57785 6.68008 2.40375 7.09949 2.26578 7.53129H1.84117C0.825976 7.53125 0 8.35719 0 9.37238V10.6276C0 11.6428 0.825976 12.4688 1.84117 12.4688H2.26578C2.40381 12.9005 2.5779 13.3199 2.78621 13.7225L2.48551 14.0232C1.75641 14.7516 1.77594 15.9187 2.48527 16.6273L3.37242 17.5145C4.08059 18.2236 5.24801 18.2441 5.97652 17.5147L6.27746 17.2138C6.68006 17.4221 7.09947 17.5962 7.53125 17.7342V18.1589C7.53125 19.1741 8.35723 20 9.37242 20H10.6276C11.6428 20 12.4688 19.1741 12.4688 18.1589V17.7342C12.9006 17.5962 13.32 17.4222 13.7226 17.2138L14.0232 17.5145C14.7503 18.2424 15.9177 18.2253 16.6273 17.5147L17.5145 16.6275C18.2236 15.9192 18.2441 14.752 17.5148 14.0234L17.2138 13.7225C17.4222 13.3199 17.5963 12.9005 17.7343 12.4687H18.1589C19.1741 12.4687 20 11.6427 20 10.6275V9.3723C20 8.35719 19.174 7.53125 18.1588 7.53125ZM10 14.3516C7.60051 14.3516 5.64844 12.3995 5.64844 10C5.64844 7.60055 7.60051 5.64844 10 5.64844C12.3995 5.64844 14.3516 7.60055 14.3516 10C14.3516 12.3995 12.3995 14.3516 10 14.3516Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1458_384">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DashboardIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = '#292929',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.5149 7.82912C17.5143 7.82873 17.5139 7.82817 17.5134 7.82775L10.1709 0.485508C9.85789 0.172336 9.44178 0 8.9992 0C8.55662 0 8.14048 0.172336 7.82737 0.485473L0.488612 7.82402C0.486151 7.82648 0.483549 7.82909 0.481229 7.83158C-0.161498 8.47796 -0.160373 9.52675 0.484393 10.1715C0.778932 10.4662 1.16783 10.6368 1.58383 10.6548C1.60085 10.6564 1.61792 10.6572 1.63506 10.6572H1.92756V16.0606C1.92756 17.13 2.79767 18 3.86706 18H6.73971C7.03098 18 7.26705 17.7637 7.26705 17.4726V13.2363C7.26705 12.7484 7.66407 12.3515 8.15201 12.3515H9.84636C10.3343 12.3515 10.7312 12.7484 10.7312 13.2363V17.4727C10.7312 17.7638 10.9672 18 11.2585 18H14.1312C15.2007 18 16.0707 17.13 16.0707 16.0606V10.6573H16.342C16.7845 10.6573 17.2006 10.4849 17.5139 10.1717C18.1593 9.52594 18.1596 8.47522 17.5148 7.82909M16.768 9.42595C16.7122 9.48209 16.6458 9.52661 16.5727 9.55693C16.4996 9.58724 16.4212 9.60276 16.342 9.60258H15.5433C15.252 9.60258 15.0159 9.83862 15.0159 10.1299V16.0606C15.0159 16.5484 14.6191 16.9453 14.1311 16.9453H11.7859V13.2363C11.7859 12.1669 10.9158 11.2968 9.84633 11.2968H8.15204C7.08252 11.2968 6.2124 12.1669 6.2124 13.2363V16.9453H3.86713C3.3793 16.9453 2.98228 16.5484 2.98228 16.0606V10.1299C2.98228 9.83862 2.74621 9.60258 2.45494 9.60258H1.66993C1.6617 9.602 1.65346 9.60162 1.64522 9.60145C1.4881 9.59871 1.34076 9.53638 1.23037 9.42581C0.99553 9.19097 0.99553 8.80882 1.23037 8.57384C1.23044 8.57381 1.23053 8.57372 1.23062 8.57355L1.23104 8.57313L8.57332 1.23117C8.62909 1.17502 8.69545 1.13051 8.76856 1.10021C8.84167 1.06992 8.92006 1.05444 8.9992 1.05469C9.16001 1.05469 9.31121 1.1173 9.42505 1.23117L16.7657 8.57166L16.7691 8.57496C17.0027 8.81023 17.0023 9.1916 16.768 9.42599"
        fill={fill}
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const FilledDashboardIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.5184 7.83081L17.5172 7.82958L10.1731 0.485718C9.86001 0.172514 9.44382 0 9.00114 0C8.55846 0 8.14223 0.172373 7.82906 0.485577L0.488717 7.82571C0.486255 7.82822 0.483794 7.83074 0.481332 7.83327C-0.161532 8.47979 -0.160407 9.5288 0.484497 10.1737C0.7791 10.4685 1.16826 10.6392 1.58432 10.6571C1.60119 10.6587 1.61823 10.6595 1.63541 10.6595H1.92811V16.0642C1.92811 17.1337 2.79828 18.0039 3.86803 18.0039H6.74127C7.03249 18.0039 7.26872 17.7677 7.26872 17.4764V13.2392C7.26872 12.7511 7.66572 12.3542 8.15376 12.3542H9.84848C10.3366 12.3542 10.7335 12.7512 10.7335 13.2392V17.4764C10.7335 17.7677 10.9696 18.0039 11.2609 18.0039H14.1342C15.204 18.0039 16.0741 17.1337 16.0741 16.0642V10.6596H16.3456C16.7881 10.6596 17.2043 10.4872 17.5176 10.174C18.1632 9.52802 18.1635 8.47722 17.5184 7.83081Z"
        fill={fill}
      />
    </svg>
  );
};